import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from './pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
    }
}

const PaymentRequisitionDisbursementPdf = () => {
    const { commaFormat } = figureFormatter();
    const { getHeader } = pdfHeaderFooter();

    const exportToPDF = (company, rows, title) => {
        const docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [30, 100, 30, 50],
            header: (currentPage) => {
                if (currentPage === 1) {
                    return getHeader(company);
                }
                return {
                    text: company.name,
                    alignment: 'center',
                    fontSize: 12,
                    margin: [0, 20, 0, 0]
                };
            },
            footer: (currentPage, pageCount) => {
                return {
                    text: `Page ${currentPage} of ${pageCount}`,
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 10, 30, 0]
                };
            },
            content: [
                {
                    text: title,
                    fontSize: 14,
                    bold: true,
                    alignment: 'center',
                    margin: [0, 0, 0, 15]
                },
                getTable(rows)
            ],
            defaultStyle: {
                fontSize: 9,
                color: '#333'
            }
        };

        pdfMake.createPdf(docDefinition).open();
    };

    const toRowList = (rows) => {
        if (Array.isArray(rows)) return rows;
        return [];
    };

    const getTable = (rows) => {
        const safeRows = toRowList(rows);
        let total = 0;
        const body = safeRows.map((item, index) => {
            total += Number(item.amount)
            return [
                { text: index + 1, alignment: 'center' },
                { text: item.date || '' },
                { text: item.voucher_no || '' },
                { text: item.party_name || '' },
                { text: item.account_head_display || '', fontSize: 8 },
                { text: item.cheque_number || '', alignment: 'center' },
                { text: item.cheque_date || '', alignment: 'center' },
                { text: commaFormat(item.amount), alignment: 'right' },
                { text: item.status || '', alignment: 'center' }
            ]
        });

        body.push([
            { text: 'Total', bold: true, colSpan: 7, alignment: 'right' },
            {}, {}, {}, {}, {}, {},
            { text: commaFormat(total), bold: true, alignment: 'right' },
            {}
        ]);

        return {
            table: {
                headerRows: 1,
                widths: [25, 70, 70, '*', '*', 60, 60, 70, 60],
                body: [
                    [
                        { text: 'SL', bold: true, alignment: 'center' },
                        { text: 'Voucher Create Date', bold: true },
                        { text: 'Voucher No', bold: true },
                        { text: 'Party Details', bold: true },
                        { text: 'Item / Account Head', bold: true },
                        { text: 'Cheque No', bold: true, alignment: 'center' },
                        { text: 'Cheque Date', bold: true, alignment: 'center' },
                        { text: 'Amount', bold: true, alignment: 'right' },
                        { text: 'Status', bold: true, alignment: 'center' }
                    ],
                    ...body
                ]
            },
            layout: {
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
            }
        };
    };

    return {
        exportToPDF
    };
};

export default PaymentRequisitionDisbursementPdf;
